import { LockIcon } from 'lucide-react';
import { Trans } from 'react-i18next';

import { Alert, AlertDescription } from '@/components/ui/alert';
import ExternalLink from '@/components/ui/external-link';

const LockedAnswersNotice = ({ i18nKey }: { i18nKey: string }) => {
  return (
    <Alert role="status">
      <LockIcon aria-hidden className="size-4" />
      <AlertDescription>
        <Trans
          i18nKey={i18nKey}
          components={[<ExternalLink key="contactSupport" className="underline hover:no-underline" href={import.meta.env.VITE_APP_SUPPORT_NEW_REQUEST_URL} />]}
        />
      </AlertDescription>
    </Alert>
  );
};
LockedAnswersNotice.displayName = 'LockedAnswersNotice';

export default LockedAnswersNotice;
